import {useState, useEffect, useCallback} from 'react'
import {ConsumerStatus} from './models/consumerModal'
import axiosClient from '../../../setup/axios/axiosClient'

export type BillingCostInfo = {
  monthToDateUsage: MonthUsageDataType
  availableBalance: number
  status: ConsumerStatus
  billingAlertAmount: number
}

export type MonthUsageDataType = {
  meetingCost: number
  recordingCost: number
  storageCost: number
  totalCost: number
}

type BillingCardInfoResponse = {
  data: BillingCostInfo
  status: number
  message: string
}
export type BillingCardData = Omit<BillingCostInfo, 'billingAlertAmount'>

export const useBillingInfo = () => {
  const [overdueAmount, setOverdueAmount] = useState(0)
  const [cardData, setCardData] = useState<BillingCardData | null>(null)
  const [billingAlertAmount, setBillingAlertAmount] = useState(0)
  const [alertUpdateLoading, setAlertUpdateLoading] = useState(false)

  // --- API Fetchers ---
  const fetchCurrentMonthCostInfo = useCallback(async () => {
    try {
      const res = await axiosClient.get<BillingCardInfoResponse>(`/billing/current-month-cost-info`)

      const {billingAlertAmount, availableBalance, monthToDateUsage, status} = res.data.data
      setCardData({
        availableBalance,
        monthToDateUsage,
        status,
      })
      setBillingAlertAmount(billingAlertAmount)
    } catch (e) {
      console.error(e)
    }
  }, [])

  const updateBillingAmount = async (obj: any) => {
    setAlertUpdateLoading(false)

    try {
      const response = await axiosClient.post("/billing/set-billing-alert-amount", obj)
    
      alert(response.data.message)
      return response.data
    } catch (err: any) {
      console.log('Error: ', err)
    } finally {
      await fetchCurrentMonthCostInfo()
      setAlertUpdateLoading(false)
    }
  }

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}').user || {}
    setOverdueAmount(user.balance || 0)

    fetchCurrentMonthCostInfo()
  }, [fetchCurrentMonthCostInfo])

  return {
    data: {overdueAmount, cardData, billingAlertAmount},
    actions: {updateBillingAmount},

    // loading state's
    alertUpdateLoading,
    setAlertUpdateLoading,
  }
}
